module.exports = __webpack_public_path__ + "static/media/verified_vendor.b9c77533.png";